import React, { useEffect } from "react";
import { Contacto as ContactoSection } from "../components/sections/Contacto";
import { Header } from "../components/layout/Header";
import Footer from "../components/layout/Footer";

export default function Contacto() {
    useEffect(() => {
        document.title = "Contacto | SmartPet";
    }, []);

    return (
        <>
            <Header />
            <main className="min-h-screen bg-[#f4f1f9] font-nunito text-[#2a1f3d]">

                {/* ====== HERO (igual que About) ====== */}
                <section className="bg-[#4a3b7a] text-center py-16 px-4 md:py-20 md:px-8 lg:py-28 lg:px-12 relative overflow-hidden">
                    <p className="text-white/60 text-xs md:text-sm font-bold tracking-[2px] uppercase mb-2">
                        Estamos para ayudarte
                    </p>
                    <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-black max-w-3xl mx-auto leading-tight">
                        Contactanos
                    </h1>
                    <p className="text-white/80 text-base md:text-lg font-semibold max-w-xl mx-auto mt-3 leading-relaxed">
                        ¿Tenés dudas sobre el producto? ¿Querés saber más antes de comprar?<br />
                        ¿Te gustaría vender SmartPet en tu local? Escribinos y te respondemos.
                    </p>
                    {/* Curva inferior */}
                    <div className="absolute bottom-0 left-0 right-0 h-12 md:h-16 bg-[#f4f1f9]" style={{ clipPath: 'ellipse(55% 100% at 50% 100%)' }} />
                </section>

                {/* ====== CONTENIDO ====== */}
                <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
                    <ContactoSection />
                </div>
            </main>
            <Footer />
        </>
    );
}